// TODO: Combine this with input component
export default {
    name: 'QSearch',
    props: {
        id: {
            type: String,
            default: 'q-search'
        },
        placeholder: {
            type: String,
            default: ''
        },
        search: {
            type: String,
            default: ''
        },
        alignment: {
            type: String,
            default: 'align-left'
        }
    },
    watch: {
        search(search) {
            this.$emit('input', search);
        }
    },
    created() {
        if (!this.placeholder) {
            this.placeholder = this.$t('HC_SEARCH');
        }
    }
};
